export default "__VITE_ASSET__$J9TAhH___"